export const validation = {
  paragraphMaxChar: 500,
  paragraph: { required: true }
}